import { Container, Row, Col, Button } from 'react-bootstrap';
import { ToastContentProps } from 'react-toastify';
import { Alert } from './_models';
import ListItem from '../../pages/AlertsPage/components/ListItem';
import i18next from '../../i18n';

const content = (alert: Alert) => {
  const close = i18next.exists('notification.close', { ns: 'alerts' })
      ? i18next.t('notification.close', { ns: 'alerts' })
      : 'Close',
    show = i18next.exists('notification.show', { ns: 'alerts' })
      ? i18next.t('notification.show', { ns: 'alerts' })
      : 'Show';

  return ({ closeToast }: ToastContentProps) => {
    const handleClose = () => {
      window.location.href = '/alerts';
      closeToast();
    };

    return (
      <Container fluid className="p-0">
        <Row className="align-items-stretch w-100 m-0">
          <Col className="d-flex flex-column justify-content-center border-end p-3">
            <ListItem alert={alert} />
          </Col>

          <Col
            xs="auto"
            className="d-flex flex-column justify-content-evenly p-0"
          >
            <Button
              variant="link"
              className="text-decoration-none fw-bold text-dark mx-2"
              onClick={closeToast}
            >
              {close}
            </Button>

            <div className="border-top" />

            <Button
              variant="link"
              className="text-decoration-none fw-bold text-primary mx-2"
              onClick={handleClose}
            >
              {show}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  };
};

export { content };
